import styled, { css } from 'styled-components';
import { darkLava } from '@/app/components/search/styles/colors.ts';

export const labelWithIconBaseStyles = css`
  border-radius: 4px;
  min-height: 28px;
  padding: 4px 8px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  width: fit-content;
  font-style: normal;
  font-size: ${({ theme }) => theme.kallisto.font.size['175']};
  line-height: ${({ theme }) => theme.kallisto.font.lineHeight['250']};

  &:first-child {
    margin-left: 0;
  }

  &:only-child {
    @media (min-width: 768px) {
      margin-bottom: 0;
    }
  }

  img {
    margin-right: 8px;

    &:last-child {
      margin-right: 0;
    }
  }
`;

export const BaseBadgeContainer = styled.div<{ $icon?: string; $iconSize?: number }>`
  ${labelWithIconBaseStyles};

  &:empty {
    display: none;
  }

  ${({ $icon }) =>
    $icon &&
    css`
      padding-left: 30px;
      background-image: url(${$icon});
      background-repeat: no-repeat;
      background-position: 8px center;
      background-size: 14px;
    `};

  ${({ $iconSize }) =>
    $iconSize &&
    css`
      background-position: ${8 + (14 - $iconSize) / 2}px center;
      background-size: ${$iconSize}px;
    `};
`;

export const SuccessNearPriceBadgeContainer = styled(BaseBadgeContainer)`
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  text-align: left;
  gap: ${({ theme }) => theme.kallisto.space.space100};
  border-radius: ${({ theme }) => theme.kallisto.border.radius.radius50};
  border: 1px solid #d1ed86;
  padding: 3px 7px;
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundSuccessSubtle};
  ${({ theme }) => theme.kallisto.mixins.font('BodySmall')};
  font-style: normal;
  color: ${({ theme }) => theme.kallisto.color.text.static.textSuccess};
  cursor: pointer;

  img {
    margin: 0;
  }

  div:empty {
    display: none;
  }
`;

export const BlackBadgeStyled = styled(BaseBadgeContainer)`
  background-color: ${darkLava};
  color: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};
`;

export const BrandPrimaryBadge = styled(BaseBadgeContainer)`
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};
  color: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};
`;

export const WhiteBadgeStyled = styled(BaseBadgeContainer)`
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundLayer02};
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  border: 1px solid ${({ theme }) => theme.kallisto.color.border.static.borderDisabled};
  padding: 3px 7px;
  pointer-events: none;
`;
